import { useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
const DEFAULT_IMAGE_TAG_HEIGHT = 74;
export const QuizWorksheetImage = ({
  imageUrl,
  alt
}: {
  imageUrl: string;
  alt?: string;
}) => {
  const [imageTagHeight, setImageTagHeight] = useState(DEFAULT_IMAGE_TAG_HEIGHT);
  const quizWorksheetImageUrl = useQuizWorksheetImage(imageUrl);
  const containerRef = useRef<HTMLDivElement>(null);
  return <div className="w-full max-w-full" ref={containerRef} style={{
    height: `${imageTagHeight}px`
  }} data-sentry-component="QuizWorksheetImage" data-sentry-source-file="QuizWorksheetImage.tsx">
      <img src={quizWorksheetImageUrl} className={'max-h-full w-auto max-w-full object-contain'} alt={alt} onLoad={e => {
      //이미지 로드 시, 이미지 실제 높이에 맞게 tag 높이를 재조정
      const {
        offsetHeight
      } = e.target as HTMLImageElement;
      setImageTagHeight(offsetHeight);
    }} height={imageTagHeight} />
    </div>;
};
export const DEFAULT_QUIZ_WORKSHEET_IMAGE_QUERY_KEY = 'quiz-worksheet-image';
const useQuizWorksheetImage = (imageUrl: string) => {
  const queryKey = [DEFAULT_QUIZ_WORKSHEET_IMAGE_QUERY_KEY, imageUrl];
  const fetchImageBlob = async () => {
    if (!imageUrl) return;
    const response = await fetch(imageUrl);
    if (!response.ok) {
      throw new Error('Failed to fetch image');
    }
    const blob = await response.blob();
    return blob;
  };
  const {
    data: blobData
  } = useQuery({
    queryKey,
    queryFn: fetchImageBlob,
    staleTime: Infinity,
    enabled: !!imageUrl
  });
  return blobData instanceof Blob ? URL.createObjectURL(blobData) : undefined;
};